import Component from './Component'

export default class CheckList extends Component {

	static _type = 'CheckList'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_els = this.base.querySelectorAll('input')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Create bound event handlers and register them
		this.inputListener = CheckList._inputListener.bind(this)
		this.updateListener = CheckList._updateListener.bind(this)
		$(this.input_els).on('input', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event
	}

	static _inputListener (event) {

		// Compile data
		let value = []
		for (let input of this.input_els) {
			if (input.checked) value.push(input.value)
		}

		// Send data to the record
		this.form.data[this.params.name] = value
	}

	static _updateListener (value, errors) {

		if (Array.isArray(value)) {
			for (let input of this.input_els) {
				input.checked = value.includes(input.value)
			}
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			$(this.input_els).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_els).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_els).off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_els
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
